import { render, staticRenderFns } from "./WorkflowList.vue?vue&type=template&id=490e7f74"
import script from "./WorkflowList.vue?vue&type=script&setup=true&lang=ts"
export * from "./WorkflowList.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./WorkflowList.vue?vue&type=style&index=0&id=490e7f74&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports